import React from "react";
import InputDescription from "components/common/InputDescription";
import Checkbox from "./Checkbox";
import { Radio } from "./imports";
import ControlLabel from "./ControlLabel";
import FormControl from "./FormControl";
import FormGroup from "./FormGroup";
import InputGroup from "./InputGroup";
import InputWrapper from "./InputWrapper";
class Input extends React.Component {
  constructor() {
    super(...arguments);
    this.getInputDOMNode = () => this.input;
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.getValue = () => {
      const { type } = this.props;
      if (!type) {
        throw new Error("Cannot use getValue without specifying input type.");
      }
      switch (type) {
        case "checkbox":
        case "radio":
          return this.getInputDOMNode().checked;
        default:
          return this.getInputDOMNode().value;
      }
    };
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.getChecked = () => this.getInputDOMNode().checked;
    this._renderFormControl = (componentClass, controlProps, children) => /* @__PURE__ */ React.createElement(
      FormControl,
      {
        inputRef: (ref) => {
          this.input = ref;
        },
        componentClass,
        ...controlProps
      },
      children
    );
    this._renderFormGroup = (children) => {
      const {
        id,
        bsStyle,
        formGroupClassName,
        wrapperClassName,
        wrapperAttributes,
        inputDescClassName,
        label,
        labelClassName,
        error,
        help,
        buttonAfter,
        addonAfter
      } = this.props;
      let input;
      if (addonAfter || buttonAfter) {
        input = /* @__PURE__ */ React.createElement(InputGroup, null, children, buttonAfter && /* @__PURE__ */ React.createElement(InputGroup.Button, null, buttonAfter), addonAfter && /* @__PURE__ */ React.createElement(InputGroup.Addon, null, addonAfter));
      } else {
        input = children;
      }
      return /* @__PURE__ */ React.createElement(FormGroup, { controlId: id, validationState: error ? "error" : bsStyle, bsClass: formGroupClassName }, label && /* @__PURE__ */ React.createElement(ControlLabel, { className: labelClassName }, label), /* @__PURE__ */ React.createElement(InputWrapper, { className: wrapperClassName, wrapperAttributes }, input, /* @__PURE__ */ React.createElement(InputDescription, { error, help, className: inputDescClassName })));
    };
    this._renderCheckboxGroup = (controlProps) => {
      const {
        id,
        buttonAfter,
        bsStyle,
        formGroupClassName,
        inputDescClassName,
        wrapperClassName,
        wrapperAttributes,
        label,
        error,
        help
      } = this.props;
      return /* @__PURE__ */ React.createElement(FormGroup, { controlId: id, validationState: error ? "error" : bsStyle, bsClass: formGroupClassName }, /* @__PURE__ */ React.createElement(InputWrapper, { className: wrapperClassName, wrapperAttributes }, buttonAfter ? /* @__PURE__ */ React.createElement(InputGroup, null, /* @__PURE__ */ React.createElement(
        Checkbox,
        {
          ref: (ref) => {
            this.input = ref;
          },
          ...controlProps
        },
        label
      ), buttonAfter && /* @__PURE__ */ React.createElement(InputGroup.Button, null, buttonAfter)) : /* @__PURE__ */ React.createElement(
        Checkbox,
        {
          ref: (ref) => {
            this.input = ref;
          },
          ...controlProps
        },
        label
      ), /* @__PURE__ */ React.createElement(InputDescription, { error, help, className: inputDescClassName })));
    };
    this._renderRadioGroup = (controlProps) => {
      const {
        id,
        bsStyle,
        formGroupClassName,
        inputDescClassName,
        wrapperClassName,
        wrapperAttributes,
        label,
        error,
        help
      } = this.props;
      return /* @__PURE__ */ React.createElement(FormGroup, { controlId: id, validationState: error ? "error" : bsStyle, bsClass: formGroupClassName }, /* @__PURE__ */ React.createElement(InputWrapper, { className: wrapperClassName, wrapperAttributes }, /* @__PURE__ */ React.createElement(
        Radio,
        {
          inputRef: (ref) => {
            this.input = ref;
          },
          ...controlProps
        },
        label
      ), /* @__PURE__ */ React.createElement(InputDescription, { error, help, className: inputDescClassName })));
    };
  }
  render() {
    const {
      id,
      type,
      children,
      label,
      name,
      // The following props need to be extracted even if they are not used
      // so they are not passed as control props to the input
      bsStyle: _bsStyle,
      formGroupClassName: _formGroupClassName,
      wrapperClassName: _wrapperClassName,
      wrapperAttributes: _wrapperAttributes,
      labelClassName: _labelClassName,
      inputDescClassName: _inputDescClassName,
      error: _error,
      help: _help,
      addonAfter: _addonAfter,
      buttonAfter: _buttonAfter,
      ...controlProps
    } = this.props;
    const commonProps = {
      type,
      label,
      name: name != null ? name : id,
      ...controlProps
    };
    if (!type) {
      return this._renderFormGroup(children);
    }
    switch (type) {
      case "text":
      case "password":
      case "email":
      case "number":
      case "file":
      case "tel":
        return this._renderFormGroup(this._renderFormControl("input", commonProps));
      case "textarea":
        return this._renderFormGroup(this._renderFormControl("textarea", commonProps));
      case "select":
        return this._renderFormGroup(this._renderFormControl("select", commonProps, children));
      case "checkbox":
        return this._renderCheckboxGroup(commonProps);
      case "radio":
        return this._renderRadioGroup(commonProps);
      default:
        console.warn(`Unsupported input type ${type}`);
    }
    return null;
  }
}
Input.defaultProps = {
  type: void 0,
  id: void 0,
  label: "",
  labelClassName: void 0,
  name: void 0,
  formGroupClassName: void 0,
  inputDescClassName: void 0,
  bsStyle: null,
  bsSize: void 0,
  value: void 0,
  placeholder: "",
  error: void 0,
  help: void 0,
  wrapperClassName: void 0,
  wrapperAttributes: void 0,
  addonAfter: null,
  buttonAfter: null,
  children: null
};
export default Input;
